import { Persistency, PersistencyKeys } from "@bounce/persistency"
import { createZustandStore } from "@bounce/state-management"

import { generateAnonymousId } from "../helpers/generateAnonymousId"

type AnonymousIdState = {
  anonymousId: string
  setAnonymousId: (anonymousId: string) => void
}

export const useAnonymousId = createZustandStore<AnonymousIdState>({
  name: "useAnonymousId",
  initializer: set => ({
    anonymousId: generateAnonymousId(),
    setAnonymousId: (anonymousId: string) => {
      set({ anonymousId })
    },
  }),
  persistStore: {
    key: "anonymous-id",
  },
})

const initializeAnonymousIdPromise = Persistency.getCookie(PersistencyKeys.ANONYMOUS_ID)
  .then(id => id && useAnonymousId.getState().setAnonymousId(id))
  .catch(() => {})

export const getAnonymousId = () => useAnonymousId.getState().anonymousId

/**
 * Ensures that the anonymous id is initialized before returning it.
 * This is useful for making sure the anonymous ID we're working with is the most up-to-date one.
 */
export const getAnonymousIdAsync = async () => {
  await initializeAnonymousIdPromise

  return getAnonymousId()
}
